export var FieldValidationError;
(function (FieldValidationError) {
    FieldValidationError["Required"] = "Required";
    FieldValidationError["Format"] = "Format";
    FieldValidationError["Length"] = "Length";
    FieldValidationError["MinAge"] = "MinAge";
    FieldValidationError["Range"] = "Range";
    FieldValidationError["EmailSuggestion"] = "EmailSuggestion";
})(FieldValidationError || (FieldValidationError = {}));
//# sourceMappingURL=field-validation-error.js.map